import { WHATSAPP_LINK } from "@/pages/home/constants";

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_LINK}
      data-whatsapp-cta
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label="Falar no WhatsApp com a Eco Tour Turismo"
      className="group fixed bottom-4 right-3 md:bottom-6 md:right-5 z-40 flex items-center justify-center md:justify-start gap-2 w-11 h-11 md:w-auto md:h-auto md:px-4 md:py-2.5 rounded-full bg-[#25D366] text-white font-bold hover:scale-105 transition-transform duration-200 cursor-pointer"
    >
      <span className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-60" />
      <i className="relative ri-whatsapp-line text-xl md:text-lg" />
      <span className="relative hidden md:inline text-sm whitespace-nowrap">Fale no WhatsApp</span>
    </a>
  );
}